import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { handleContactClick } from './Header';

function Footer() {
    const navigate = useNavigate();

    return (
        <div>
            <footer className="py-8 bg-gray-50">
                <div className="container mx-auto text-center">
                    <nav className="flex flex-wrap justify-center space-x-6 text-gray-500">
                        <Link to="/services" className="hover:text-gray-700">Services</Link>
                        <span className="text-gray-300 hidden md:inline">|</span>
                        <Link to="/" className="hover:text-gray-700">Blogs</Link>
                        <span className="text-gray-300 hidden md:inline">|</span>
                        <Link to="/work" className="hover:text-gray-700">Builds</Link>
                        <span className="text-gray-300 hidden md:inline">|</span>
                        <Link to="/terms-of-service" className="hover:text-gray-700">Terms</Link>
                        <span className="text-gray-300 hidden md:inline">|</span>
                        <button
                            onClick={() => handleContactClick(navigate, () => { })} // Pass a no-op function for setIsMenuOpen
                            className="cursor-pointer hover:text-gray-700"
                        >
                            Contact
                        </button>
                    </nav>
                    <div className="mt-6">
                        <hr className="border-gray-200 w-16 mx-auto" />
                    </div>
                    <div className='mt-6 flex flex-col items-center justify-between gap-2 text-gray-500 md:flex-row'>
                        <p className="text-gray-500">30N South Gould Street, Sheridan, WY 82801</p>
                        <p>© {new Date().getFullYear()} Learn With Stack. All rights reserved.</p>
                        <div className="flex items-center gap-4">
                            <Link to='/privacy-policy' className="hover:text-gray-700">Privacy Policy</Link>
                            <Link to="/terms-of-service" className="hover:text-gray-700">Terms &amp; Conditions</Link>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    );
}

export default Footer;
